import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'], // FIXME: Set correct permissions once those are decided upon and implemented
};
